// Ring-buffer log for live-update / navigation diagnostics. No PII: only
// event names, article ids, counts and timings. Readable via window.__liveLog().
const MAX = 200;
const buf = [];

export function liveLog(event, data = {}) {
    const entry = { t: new Date().toISOString(), event, ...data };
    buf.push(entry);
    if (buf.length > MAX) buf.shift();
    if (typeof window !== "undefined" && window.localStorage?.getItem("live-debug") === "1") {
        // eslint-disable-next-line no-console
        console.debug("[live]", event, data);
    }
}

if (typeof window !== "undefined") window.__liveLog = () => buf.slice();
